import { Helmet } from "react-helmet";
import { IdFormContainer } from '../components/id-form.container';
 
 
 
export const ToolsIdForm: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Tools - ID Form</title>
      </Helmet>
      <IdFormContainer />
    </>
  );
};